import {calculateWidthInPixelsForThreadByThread} from './calculate-width-in-pixels-for-thread-by-thread';

export function convertDentsToPixels(dents: number, threadByThread: boolean, nrColumnsForWeftSelection: number, nrCloths: number, nrGroundYarns: number): number {
  return threadByThread ? calculateWidthInPixelsForThreadByThread(dents, nrColumnsForWeftSelection, nrCloths, nrGroundYarns) : dents;
}
